var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ 'icon-text-checkbox': true, checked: (this.checked), labeled: (!this.nolabel) },on:{"click":_vm.onClick}},[_c('div',{staticClass:"image-wrap"},[_vm._t("image")],2),(!_vm.nolabel)?_c('span',[_vm._t("label")],2):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }